module.exports = __webpack_public_path__ + "img/introduce.369f6396.svg";